import { TAppState as TAppStateCore } from '@core/js/components/system/App/store/types';
import { actionTypes as actionTypesCore } from '@core/js/components/system/App/store/constants';
import {
    defaultState as defaultStateOriginal,
    reducer as coreReducer
} from '@core/js/components/system/App/store/reducer';

import * as TypesBuzz from './buzz/types';
import { actionTypes } from './buzz/constants';
import { TAppConfigTag, TConfigTags } from '@interlayer/js/components/system/TagManager/buzz/types';
import { CONFIG_TAG_TYPE, TAG_TYPE_BUZZ } from '@interlayer/js/components/system/TagManager/buzz/constants';

export const defaultState: TypesBuzz.TAppState = {
    ...defaultStateOriginal,
    games: {},
    gamesFeedsObject: {},
    showMobileMenu: false,
    showAccountMenu: false,
    isFeaturedBanner: false,
    isShowLocalPopup: false,
    isShowPopupAlreadyUser: false,
    menuItemsOnlyIsLoggedIn: {},
    urlRedirectBackAfterDeposit: '',
    isLoadingMenuItems: true,
    isShowPlayBingoButton: false,
    showTagsList: Object.values(TAG_TYPE_BUZZ).reduce((acc, type) => ({
        ...acc,
        [type]: false
    }), {} as Record<TAG_TYPE_BUZZ, boolean>),
    isAdminLoggedIn: false,
    activeConfigTags: Object.values(CONFIG_TAG_TYPE).reduce((acc, type) => ({
        ...acc,
        [type]: []
    }), {} as TConfigTags),
    resizeData: {
        id: '',
        width: window.innerWidth,
        height: window.innerHeight
    },
    lossLimits: {
        inputType: '',
        dailyLimit: '',
        weeklyLimit: '',
        limitAction: '',
        monthlyLimit: '',
        sessionLimit: '',
        useDailyLimit: false,
        useWeeklyLimit: false,
        useMonthlyLimit: false,
        useSessionLimit: false
    },
    isDownloadAppOpen: false,
    positionStickyBtn: ''
};

export const reducer = (state = defaultState, action: TypesBuzz.TAppAction): TypesBuzz.TAppState => {
    switch (action.type) {
        case actionTypes.SET_SHOW_MOBILE_MENU: {
            return {
                ...state,
                showMobileMenu: action.payload
            };
        }

        case actionTypes.SET_IS_FEATURED_BANNER: {
            return {
                ...state,
                isFeaturedBanner: action.payload
            };
        }

        case actionTypes.SET_IS_SHOW_POPUP_ALREADY_USER: {
            return {
                ...state,
                isShowPopupAlreadyUser: action.payload
            };
        }

        case actionTypes.SET_IS_SHOW_LOCAL_POPUP: {
            return {
                ...state,
                isShowLocalPopup: action.payload
            };
        }

        case actionTypes.SET_SHOW_ACCOUNT_MENU: {
            return {
                ...state,
                showAccountMenu: action.payload
            };
        }

        case actionTypes.SET_URL_REDIRECT_BACK_AFTER_DEPOSIT: {
            return {
                ...state,
                urlRedirectBackAfterDeposit: action.payload
            };
        }

        case actionTypesCore.UPDATE_MENU_ITEMS: {
            return {
                ...state,
                isLoadingMenuItems: false,
                menuItems: action.payload.menuItems,
                menuItemsOnlyIsLoggedIn: action.payload.menuItemsOnlyIsLoggedIn
            };
        }

        case actionTypes.SET_IS_SHOW_PLAY_BINGO_BUTTON: {
            return {
                ...state,
                isShowPlayBingoButton: action.payload
            };
        }

        case actionTypes.SET_RESIZE_DATA: {
            return {
                ...state,
                resizeData: action.payload
            };
        }

        case actionTypes.SET_ACTIVE_TAG_CONFIG: {
            return {
                ...state,
                activeConfigTags: {
                    ...state.activeConfigTags,
                    [action.payload.tagTypeId]: [
                        ...state.activeConfigTags[action.payload.tagTypeId],
                        action.payload
                    ]
                }
            };
        }

        case actionTypes.REMOVE_ACTIVE_TAG_CONFIG: {
            return {
                ...state,
                activeConfigTags: {
                    ...state.activeConfigTags,
                    [action.payload.tagTypeId]: (state.activeConfigTags[action.payload.tagTypeId] as TAppConfigTag[])
                        .filter(({ tagName }) => {
                            return tagName !== action.payload.tagName;
                        })
                }
            };
        }

        case actionTypes.SET_IS_SHOW_TAG: {
            return {
                ...state,
                showTagsList: {
                    ...state.showTagsList,
                    [action.payload.type]: action.payload.isShow
                }
            };
        }

        case actionTypes.SET_IS_DOWNLOAD_APP_OPEN: {
            return {
                ...state,
                isDownloadAppOpen: action.payload
            };
        }

        case actionTypes.SET_POSITION_STICKY_BUTTON: {
            return {
                ...state,
                positionStickyBtn: action.payload
            };
        }

        default: {
            return coreReducer(state as TAppStateCore, action) as TypesBuzz.TAppState;
        }
    }
};
